import {connect} from '../../../app/connect';
import IssueAttributesAdmin from './IssueAttributesAdmin';
import {
  changeLocationAction,
  deleteIssueAttributeAction,
  fetchIssuesCustomizationMetadata,
  trackEvent
} from '../../../app/actions';
import {
  getIssueAttributesDefinitionsMappedEntities,
  isErrorLoadingIssueAttributesDefinitions,
  getFieldAdminPageDataLoading,
  isDeletingIssueAttributesDefinition,
  isErrorLoadingIssueAttributesMappings
} from '../../../app/selectors';

const mapStateToProps = state => ({
  data: getIssueAttributesDefinitionsMappedEntities(state),
  error: isErrorLoadingIssueAttributesDefinitions(state) || isErrorLoadingIssueAttributesMappings(state),
  isLoading: getFieldAdminPageDataLoading(state),
  isDeleting: isDeletingIssueAttributesDefinition(state)
});

const mapDispatchToProps = {
  deleteIssueAttributeAction,
  changeLocationAction,
  fetchIssuesCustomizationMetadata,
  trackEvent
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(IssueAttributesAdmin);
